import { FeedbackStatusEnum, NO_VALUE_DISPLAY } from "@ryde/shared";
import { deepPurpleMui, lightBlueMui, redMui, rydeColors } from "@ryde/theme";

export interface IStatusIndicatorFeedback {
  status: FeedbackStatusEnum | null | undefined;
  fontSize?: string;
}

export interface IStatusIndicatorFeedbackControl {
  $bgColor: string;
  $leftColor: string;
  color: string;
  $translateKey: string;
  $dataE2eValue?: string;
  fontSize?: string;
}

export const StatusIndicatorFeedbackConst: Record<
  FeedbackStatusEnum,
  IStatusIndicatorFeedbackControl
> = {
  [FeedbackStatusEnum.New]: {
    $bgColor: lightBlueMui._50,
    $leftColor: lightBlueMui._700,
    color: rydeColors.black,
    $translateKey: "New",
    $dataE2eValue: "New",
  },
  [FeedbackStatusEnum.WaitingForSupplier]: {
    $bgColor: deepPurpleMui._50,
    $leftColor: rydeColors.venetianNights,
    color: rydeColors.black,
    $translateKey: "WaitingForSupplier",
    $dataE2eValue: "Waiting for supplier",
  },
  [FeedbackStatusEnum.WaitingForAdmin]: {
    $bgColor: rydeColors.princetonOrange,
    $leftColor: rydeColors.mochaccino,
    color: rydeColors.white,
    $translateKey: "WaitingForAdmin",
    $dataE2eValue: "Waiting For Admin",
  },
  [FeedbackStatusEnum.Canceled]: {
    $bgColor: redMui.A200,
    $leftColor: rydeColors.mochaccino,
    color: rydeColors.white,
    $translateKey: "Canceled",
    $dataE2eValue: "Canceled",
  },
  [FeedbackStatusEnum.Closed]: {
    $bgColor: rydeColors.greenishTeal,
    $leftColor: rydeColors.thujaGreen,
    color: rydeColors.white,
    $translateKey: "Closed",
    $dataE2eValue: "Closed",
  },
};

export const EmptyStatusIndicatorFeedback: IStatusIndicatorFeedbackControl = {
  $bgColor: "transparent",
  $leftColor: "transparent",
  color: rydeColors.black,
  $translateKey: NO_VALUE_DISPLAY,
  $dataE2eValue: NO_VALUE_DISPLAY,
};
